import type { ReactElement } from 'react'
import type { ShortlistApplicantFeedbackData } from '~/domains/actions/types'
import {
  feedbackAnswer,
  feedbackSummary,
  feedbackVerdict,
  reportComment
} from './ShortlistReport.css'

type ShortlistApplicantFeedbackProps = {
  feedback: ShortlistApplicantFeedbackData
}

export const ShortlistApplicantFeedback = ({
  feedback
}: ShortlistApplicantFeedbackProps): ReactElement => (
  <div className={feedbackSummary}>
    <div className={feedbackVerdict}>
      {feedback.accepted !== null && (
        <span className={feedbackAnswer[feedback.accepted ? 'yes' : 'no']}>
          {feedback.accepted ? 'Retenu' : 'Non retenu'}
        </span>
      )}
      {feedback.rank !== null && (
        <span>
          Classé {feedback.rank} sur {feedback.total}
        </span>
      )}
    </div>
    {feedback.comment && (
      <div className={reportComment}>« {feedback.comment} »</div>
    )}
  </div>
)
